/**
 * THEME MANAGER
 * Motor de Marca Blanca. Lee `window.PUBLISHER_CONFIG` y aplica los estilos y textos en toda la aplicación.
 */

const ThemeManager = {
    init() {
        console.log('🎨 Inicializando ThemeManager...');
        // Aplicar el tema configurado por defecto
        if (window.PUBLISHER_CONFIG) {
            this.applyThemeConfig(window.PUBLISHER_CONFIG);
        }
    },

    /**
     * Aplica un tema completo desde un objeto de configuración
     */
    applyThemeConfig(config) {
        if (!config || !config.colors || !config.branding) {
            console.error('❌ Configuración de tema inválida');
            return;
        }

        const root = document.documentElement;

        // 1. APLICAR COLORES (CSS Variables)
        root.style.setProperty('--color-primary', config.colors.primary);
        root.style.setProperty('--color-primary-dark', config.colors.primaryDark);
        root.style.setProperty('--color-primary-light', config.colors.primaryLight);
        
        root.style.setProperty('--color-secondary', config.colors.secondary);
        root.style.setProperty('--color-secondary-dark', config.colors.secondaryDark);
        root.style.setProperty('--color-secondary-light', config.colors.secondaryLight);
        
        root.style.setProperty('--color-accent', config.colors.accent);
        root.style.setProperty('--color-accent-dark', config.colors.accentDark);

        // Actualizar el gradiente animado de fondo si se proporcionan colores de fondo
        if (config.colors.bgDarkest) {
            const gradient = `linear-gradient(-45deg, ${config.colors.bgDarkest}, ${config.colors.bgMid}, ${config.colors.bgLight}, ${config.colors.bgLighter})`;
            document.body.style.background = gradient;
            document.body.style.backgroundSize = '400% 400%';
        }

        // 2. APLICAR BRANDING (Textos y Logos)
        this.updateBrandingElements(config.branding);

        console.log(`✅ Tema "${config.id || 'Custom'}" aplicado correctamente.`);
    },

    /**
     * Cambia el tema activo por uno de los predefinidos (Para Demostraciones)
     */
    applyTheme(themeId) {
        if (window.PUBLISHER_THEMES && window.PUBLISHER_THEMES[themeId]) {
            window.PUBLISHER_CONFIG = window.PUBLISHER_THEMES[themeId];
            this.applyThemeConfig(window.PUBLISHER_CONFIG);
        } else {
            console.error(`❌ Tema "${themeId}" no encontrado.`);
        }
    },

    /**
     * Actualiza el DOM con los textos y logos de la editorial
     */
    updateBrandingElements(branding) {
        // Actualizar títulos principales (Splash, Login, Welcome)
        const mainTitles = document.querySelectorAll('.main-title');
        mainTitles.forEach(el => {
            el.textContent = branding.appName;
        });

        // Actualizar el footer "branding" sswork-brand
        const brandFooters = document.querySelectorAll('#sswork-brand .branding');
        brandFooters.forEach(el => {
            el.textContent = branding.companyName;
            if (!branding.showBrandFooter) {
                el.style.display = 'none';
            } else {
                el.style.display = 'inline-block';
            }
        });

        // Document title
        document.title = branding.appName;

        // Si la editorial provee un logo en imagen, podríamos reemplazar los títulos con imágenes aquí
        if (branding.logoUrl) {
            // Ejemplo de implementación futura: ocultar texto y mostrar img
            // mainTitles.forEach(el => el.innerHTML = `<img src="${branding.logoUrl}" alt="${branding.appName}" class="publisher-logo">`);
        }
    }
};

// Exponer globalmente y auto-inicializar si el DOM ya está listo o esperar a DOMContentLoaded
window.ThemeManager = ThemeManager;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ThemeManager.init());
} else {
    ThemeManager.init();
}
